

var addBtn = document.querySelector('[name="add"]');
var priceContainer = document.querySelector('.price-per-item__container');
var addBtnClon = addBtn.cloneNode(true);
addBtnClon.style.marginBottom = "0px";
console.log('addBtn', addBtn)
addBtnClon.classList.add('add-button')
addBtnClon.id = `${addBtnClon.id}--clone`
let idEndSubmit = 0
const endSubmit = () => {
    console.log(idEndSubmit)
    if(idEndSubmit && !addBtn.classList.contains('loading')) {
        addBtnClon.classList.remove('loading')
        addBtnClon.setAttribute('aria-disabled', false);
        clearInterval(idEndSubmit)
    }
    console.log(idEndSubmit)
}
addBtnClon.addEventListener('click', ()=>{
    addBtn.click()
    addBtnClon.classList.add('loading')
    addBtnClon.setAttribute('aria-disabled', true);
    idEndSubmit = setInterval(()=>endSubmit(), 300)
})
priceContainer.appendChild(addBtnClon);
addBtn.style.display = "none";
